import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/round-button';
import '../components/code-segment';

import '../styles/docs.less';


export default new Mosaic({
    name: 'shadow-page',
    created() {
        window.scrollTo({ top: 0 });

        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'block';

        if(menubtn.onclick) return;

        menubtn.onclick = () => {
            const menu = document.getElementById('doc-menu');
            menu.style.transform = 'translateX(0%)';
        }
    },
    view() {
        return html`<div class='doc-page'>
            <navigation-bar></navigation-bar>
            
            <h1 class='section-title' tabindex='0'>👻 Using the Shadow DOM</h1>
            <p class='section-text' tabindex='0'>
                The Shadow DOM is a new innovation to HTML and JavaScript that allows
                us to encapsulate styles and markup within our components so that they do not
                leak out into other parts of our web apps. In this section we will explore the
                <b>useShadow</b> option, which is how Mosaic allows us to use the Shadow DOM.
            </p>

            <h1 class='section-title' tabindex='0'>useShadow</h1>
            <p class='section-text' tabindex='0'>
                The useShadow option allows us to quickly say whether or not we want our component
                to use the Shadow DOM. If the option is set to true, then the entire component view
                will be wrapped inside of an <i>open shadow root</i>. When you inspect the element
                inside of your web console you will see the shadow root wrapping around the element.
            </p>
            <p class='section-text' tabindex='0'>
                The useShadow option is pretty straight forward to use and understand. Since
                it does not get much deeper than that we will discuss a very good use case for it,
                which is in design systems. Often times, when working on multiple similar projects
                teams will want to consolidate their components into a library that they can pick
                from in order to make sure all of their apps have the same look and feel. This is
                where the Shadow DOM becomes useful.
            </p>
            <p class='section-text' tabindex='0'>
                By encapsulating our components, we can ensure that no matter where we use them
                they will still look and feel exactly how we originally intend for them to. No
                matter which project we add our encapsulated components to, their styles and
                markup will not be affected be outside code. If you would like to read more about
                the Shadow DOM, click here: 
                <a href='https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_shadow_DOM'>
                    https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_shadow_DOM
                </a>
            </p>
            <br>
            
            <p class='section-text' tabindex='0' style='text-align:center;'>
                Next we will dive into the miscellaneous topics of Mosaic,
                starting with the built-in, global state manager called 
                <i>Portfolio</i>.
            </p>
            <div style="text-align: center;">
                <round-button onclick='${() => this.router.send('/mixins')}'>
                    <ion-icon name="arrow-round-back"></ion-icon>
                    Mixins
                </round-button>
                &nbsp;&nbsp;
                <round-button onclick='${() => this.router.send('/portfolio')}'>
                    Portfolio
                    <ion-icon name="arrow-round-forward"></ion-icon>
                </round-button>
            </div>

            <app-footer></app-footer>
        </div>`
    }
});